import { render, staticRenderFns } from "./all-certificate.vue?vue&type=template&id=a3d29a34&scoped=true&"
import script from "./all-certificate.vue?vue&type=script&lang=js&"
export * from "./all-certificate.vue?vue&type=script&lang=js&"
import style0 from "./all-certificate.vue?vue&type=style&index=0&id=a3d29a34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d29a34",
  null
  
)

export default component.exports